<style scoped> 
    .product-card {
        border: 1.5px solid #ddd; /* Borde del card */
        border-radius: 8px; /* Bordes redondeados */
        padding: 16px; /* Espaciado interno */
        margin-bottom: 16px; /* Espaciado inferior entre cards */
        background-color: #f9f9f9; /* Color de fondo */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra suave */
    }

    .selected-card {
        border: 2px solid rgba(78, 60, 238, 0.58); /* Cambia este valor al color que desees */
    }

    .btn-copy{
        color: gray;
    }
</style>

<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 mb-4 mb-lg-0 mb-xl-0">
        <strong>
            <app-breadcrumb :page-title="$t('products on order')" :icon="'user-check'" />
        </strong>
        <div class="card border-0 card-with-shadow w-100">
            <div v-for="(product, index) in selectedProducts"
                :key="index"
                class="card-body px-4 product-card"
                :class="{ 'selected-card': selectedCardIndex == product?.pd_unique_id }"
                @click="$emit('handleCardClick', product, parseInt(product?.pd_unique_id))"
                style="cursor: pointer"
            >
                <div class="row">
                    <div class="col-md-10 col-sm-10">
                        <h5 class="card-title">
                            <!-- {{ product?.pd_typedata?.value ?? ' ' }}
                            {{ product?.pd_typedata?.value && product?.pd_product?.name ? ', ' : ' ' }} -->
                            {{ product?.pd_item?.value ?? '' }}
                            {{ product?.pd_product?.name ?? '' }}
                        </h5>
                        <p class="card-text">
                            <!-- {{ product?.pd_cut_size?.value ?? '' }}
                            {{ product?.pd_cut_size?.value && product?.pd_grade?.value ? ', ' : ' ' }}
                            {{ product?.pd_grade?.value ?? '' }}
                            {{ product?.pd_grade?.value && product?.pd_crop?.value ? ', ' : ' ' }}
                            {{ product?.pd_crop?.value ?? '' }} -->
                            {{ product?.pd_typedata?.value ? product?.pd_typedata?.value : '' }}
                            {{ product?.pd_subCategory?.value ? `  ${product?.pd_subCategory?.value}` : ' ' }}
                            {{ product?.pd_product?.name ? `, ${product?.pd_product?.name}` : ' ' }}
                            {{ product?.pd_feature?.value ? `, ${product?.pd_feature?.value}` : ' ' }}
                            {{ product?.pd_cut_size?.value ? `, ${product?.pd_cut_size?.value}` : ' ' }}
                            {{ product?.pd_grade?.value ? `, ${product?.pd_grade?.value}` : ' ' }}
                            {{ product?.pd_crop?.value ? `, ${product?.pd_crop?.value}` : ' ' }}
                            {{ `product of ${country}` }}
                            {{ product?.pd_note ? `- ${product?.pd_note}` : ' ' }} 
                        </p>
                    </div>
                    <div class="col-md-2 col-sm-2 d-flex align-items-center">
                        <i 
                            class="fas fa-copy mr-3" 
                            :class="read ? 'text-muted' : 'btn-copy'"
                            @click.stop="!read && $emit('duplicateProduct', index)"  
                            :style="{ 
                                cursor: read ? 'not-allowed' : 'pointer', 
                                fontSize: '24px',
                                opacity: read ? 0.5 : 1
                            }"
                        ></i>

                        <i 
                            class="fas fa-trash" 
                            :class="read ? 'text-muted' : 'text-danger'"
                            @click.stop="!read && $emit('removeProduct', index)" 
                            :style="{ 
                                cursor: read ? 'not-allowed' : 'pointer', 
                                fontSize: '24px',
                                opacity: read ? 0.5 : 1
                            }"
                            ></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductOrder',
    props: {
        selectedProducts: {
            type: Array,
            default: () => []
        },
        selectedCardIndex : {
            type : Number,
            default : null,
        },
        country : {
            type: String,
            default : '',
        },
        read : {
            type: Boolean,
            default : false,
        }
    },
    mounted(){ 
    },
    emits: ['handleCardClick', 'removeProduct']
}
</script>